export default {
  NONE: 0,
  HAIRLINE: 1,
  THIN: 2,
  THICK: 4,
  HEAVY: 8
};
